import {
  CHANGE_LAYOUT,
  CHANGE_LAYOUT_WIDTH,
  CHANGE_SIDEBAR_THEME,
  CHANGE_SIDEBAR_TYPE,
  CHANGE_TOPBAR_THEME,
  SHOW_RIGHT_SIDEBAR,
  CHANGE_PRELOADER,
  TOGGLE_LEFTMENU,
  SHOW_SIDEBAR,
  CHANGE_COLOR,
  CHANGE_MODE
} from "./actionTypes"

interface LayoutState {
  layoutColor: string
  layoutMode: string
  layoutType: string
  layoutWidth: string
  leftSideBarTheme: string
  leftSideBarType: string
  topbarTheme: string
  isPreloader: boolean
  showRightSidebar: boolean
  isMobile: boolean
  showSidebar: boolean
  leftMenu: boolean
}

interface LayoutAction {
  type: string
  payload?: any
}

const INIT_STATE: LayoutState = {
  layoutColor:"default",
  layoutMode:"light",
  layoutType: "vertical",
  layoutWidth: "fluid",
  leftSideBarTheme: "light",
  leftSideBarType: "default",
  topbarTheme: "light",
  isPreloader: false,
  showRightSidebar: false,
  isMobile: false,
  showSidebar: true,
  leftMenu: false,
}

const Layout = (state: LayoutState = INIT_STATE, action: LayoutAction): LayoutState => {
  switch (action.type) {
    case CHANGE_LAYOUT:
      return {
        ...state,
        layoutType: action.payload,
      }

    case CHANGE_COLOR:
    return {
      ...state,
      layoutColor: action.payload,
    }

    case CHANGE_MODE:
    return {
      ...state,
      layoutMode: action.payload,
    }

    case CHANGE_PRELOADER:
      return {
        ...state,
        isPreloader: action.payload,
      }

    case CHANGE_LAYOUT_WIDTH:
      return {
        ...state,
        layoutWidth: action.payload,
      }
    case CHANGE_SIDEBAR_THEME:
      return {
        ...state,
        leftSideBarTheme: action.payload,
      }
    case CHANGE_SIDEBAR_TYPE:
      return {
        ...state,
        leftSideBarType: action.payload?.sidebarType || action.payload,
      }
    case CHANGE_TOPBAR_THEME:
      return {
        ...state,
        topbarTheme: action.payload,
      }
    case SHOW_RIGHT_SIDEBAR:
      return {
        ...state,
        showRightSidebar: action.payload,
      }
    case SHOW_SIDEBAR:
      return {
        ...state,
        showSidebar: action.payload,
      }
    case TOGGLE_LEFTMENU:
      return {
        ...state,
        leftMenu: action.payload,
      }

    default:
      return state
  }
}

export default Layout
